import { Link, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard, User as UserIcon, Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Button } from "@/components/ui/button";

export const Header = () => {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 glass-header border-b border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <img src="/logo-mark.png" alt="NutriScan" className="h-9 w-9 rounded-xl group-hover:scale-105 transition-transform" />
          <span className="font-heading font-extrabold text-xl text-slate-900 tracking-tight">NutriScan</span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-3">
          <LanguageSwitcher />
          {user?.role === "admin" && (
            <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="nav-admin-button" className="rounded-full">
              <LayoutDashboard className="w-4 h-4 mr-1.5" /> {t("common.adminPanel")}
            </Button>
          )}
          {user && (
            <Button variant="ghost" size="sm" onClick={() => navigate("/")} data-testid="nav-profile-button" className="rounded-full">
              <Heart className="w-4 h-4 sm:mr-1.5" /><span className="hidden sm:inline">{t("common.profile")}</span>
            </Button>
          )}
          {user ? (
            <div className="flex items-center gap-2">
              <span className="hidden sm:flex items-center gap-1.5 text-sm text-muted-foreground">
                <UserIcon className="w-4 h-4" /> {user.name || user.email}
              </span>
              <Button variant="outline" size="sm" onClick={() => { logout(); navigate("/"); }} data-testid="logout-button" className="rounded-full">
                <LogOut className="w-4 h-4 sm:mr-1.5" /><span className="hidden sm:inline">{t("common.logout")}</span>
              </Button>
            </div>
          ) : (
            <Button size="sm" onClick={() => navigate("/auth")} data-testid="nav-login-button" className="rounded-full bg-primary hover:bg-primary/90">
              {t("common.login")}
            </Button>
          )}
        </nav>
      </div>
    </header>
  );
};
